import styles from "./DropGuide.module.scss"

import React, { memo } from "react"
import { createPortal } from "react-dom"

interface Props {
  /** 안내를 띄울 메시지 영역. 없으면 렌더하지 않는다 */
  container: Element | null
}

/** 파일을 끌고 있는 동안 메시지 영역에 띄우는 드롭 안내 */
function DropGuide({ container }: Props) {
  if (!container) return null

  return createPortal(
    <div className={styles.dropGuide}>
      <svg className={styles.dropGuideIcon} viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm0 16H5v-2.9l3.4-3.4 3 3 4.6-4.6L19 14.2V19Z"
          fill="currentColor"
        />
        <circle cx="8.8" cy="8.3" r="1.8" fill="currentColor" />
      </svg>
      <p>파일을 드래그하여 업로드하세요.</p>
    </div>,
    container,
  )
}

export default memo(DropGuide)
